import { render, staticRenderFns } from "./MemberDependents.vue?vue&type=template&id=db457494&scoped=true"
import script from "./MemberDependents.vue?vue&type=script&lang=js"
export * from "./MemberDependents.vue?vue&type=script&lang=js"
import style0 from "./MemberDependents.vue?vue&type=style&index=0&id=db457494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db457494",
  null
  
)

export default component.exports